import { render, staticRenderFns } from "./editParkingSpace.vue?vue&type=template&id=36888682"
import script from "./editParkingSpace.vue?vue&type=script&lang=js"
export * from "./editParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports